export enum USER_EVENT_TYPE {
	Created = 0,
	AddEmail = 1,
	SendEmailActivation = 2,
	Activated = 3,
	Deleted = 4,
	PoliciesAccepted = 5,
}
